'use client';

import { useTranslation } from '@/lib/i18n/i18n.client';

import HeadingDC from '@/decodo/components/atoms/Heading';
import LinkButtonDC from '@/decodo/components/atoms/LinkButton';

export default function ErrorPageContent({ message }: { message?: string }) {
  const { texts } = useTranslation();

  return (
    <main>
      <section className='layout bg-base-white flex min-h-screen flex-col items-center justify-center p-9 text-center text-black'>
        <div className='flex w-full max-w-[753px]'>
          <img
            src='/svg/404.svg'
            alt='404 Error'
            className='h-auto w-full max-w-full'
          />
        </div>

        <HeadingDC level='h3'>
          {message ?? texts.error_page.oops_not_found}
        </HeadingDC>
        <div className='mt-6'>
          <LinkButtonDC variant='filled' color='primary' href='/'>
            {texts.error_page.back_to_home}
          </LinkButtonDC>
        </div>
      </section>
    </main>
  );
}
